import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import InsertPageBreakRoundedIcon from "@mui/icons-material/InsertPageBreakRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import TaskRoundedIcon from "@mui/icons-material/TaskRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { pdfjs } from "react-pdf";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import UserFilter from "../../../app/core/components/UserFilter/UserFilter";
import { useCreateDocumentMutation } from "../../api/admin/gestisciDocumentiApi";
import { useGetUsersQuery } from "../../api/admin/gestisciUtentiApi";
import SplitDocumentPage from "../../common/SplitDocumentPage/SplitDocumentPage";
import { getUploadURL, uploadFile } from "./CaricaDocumentiSlice";
import { FormCreaUtente as FormCreaUtenteAdmin } from "../CreaUtentePage/FormCreaUtente/FormCreaUtente";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import { ROLE, SUB_ROLE } from "../../../utils/constants/profiles";
import {
  useGetAdminCategoriesQuery,
  useGetAdminTypologiesQuery,
} from "../../api/admin/categoriesApi";
import { actions as actionCategories } from "../../../app/categoriesSlice";
import { actions as actionsTypologies } from "../../../app/enumsSlice";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import {
  useCreatePracticeDocumentMutation,
  useGetPracticeManagementQuery,
} from "../../api/admin/gestisciPraticheApi";
import { useTranslation } from "react-i18next";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import LockScreen from "../../../app/core/components/CoreLockScreen/LockScreen";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import JSZip from "jszip";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";

const CaricaDocumentiPage = () => {
  const location = useLocation();
  const userFromLocation = location.state;
  const appConfig = useSelector((state) => state.app.appConfig);
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState("");
  const [selectedUser, setSelectedUser] = useState(userFromLocation || "");
  const [selectedPractice, setSelectedPractice] = useState(null);
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [checkedEsitoPratica, setCheckedEsitoPratica] = useState({
    generalCheckBox: false,
    showInfo: false,
  });
  const [progress, setProgress] = useState(0);
  const [isUploadEnded, setIsUploadEnded] = useState(false);
  const [open, setOpen] = useState(false);
  const [isDocumentDivided, setIsDocumentDivided] = useState({});
  const [file, setFile] = useState({});
  const [numPages, setNumPages] = useState();
  const [pages, setPages] = useState({});
  const [creaUtente, setCreaUtente] = useState(false);
  const [isAllDocumentsUploaded, setIsAllDocumentsUploaded] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const role = useSelector((state) => state.app.role);
  const accessToken = useSelector((state) => state.app.accessToken);
  const subrole = useSelector((state) => state.app.subRole);

  const { data: adminCategories } = useGetAdminCategoriesQuery(accessToken);
  const { data: adminTypologies } = useGetAdminTypologiesQuery(accessToken);

  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery({
    page: { startRow: 0, endRow: 10 },
    value: debouncedInputUserValue,
    accessToken,
    extraFilters: {
      AdminConfirmed: {
        filterType: "string",
        type: "equals",
        filter: true,
      },
    },
  });

  const { data: practicesData } = useGetPracticeManagementQuery(
    {
      page: { startRow: 0, endRow: 1000 },
      userFilter: selectedUser
        ? `${selectedUser.name} ${selectedUser.surname}`
        : "",
      showAll: true,
      orderDirection: "desc",
      valueToOrderBy: "name",
    },
    { skip: !selectedUser }
  );

  const [createDocument] = useCreateDocumentMutation();
  const [createPracticeDocument] = useCreatePracticeDocumentMutation();

  const loadPdf = async (file) => {
    if (file.type === "application/pdf" && file?.files && file?.files[0]?.url) {
      const pdf = await pdfjs.getDocument(
        `${process.env.REACT_APP_API_URL}${file?.files[0]?.url}`
      ).promise;
      setPages((prevPage) => {
        return { ...prevPage, [file.id]: pdf.numPages };
      });
    }
  };

  useEffect(() => {
    if (adminCategories?.Data)
      dispatch(actionCategories.setMacroCategories(adminCategories?.Data));
    if (adminTypologies?.Data)
      dispatch(actionsTypologies.setIdentTypologies(adminTypologies?.Data));
  }, [adminCategories, adminTypologies, dispatch]);

  useEffect(() => {
    if (file) {
      const loadPdf = async () => {
        try {
          const pdf = await pdfjs.getDocument(
            `${process.env.REACT_APP_API_URL}${file?.files[0]?.url}`
          ).promise;
          setNumPages(pdf.numPages);
        } catch (error) {
          console.log(error);
        }
      };
      loadPdf();
    }
  }, [file]);

  const clear = () => {
    setIsUploadEnded(false);
    setIsAllDocumentsUploaded(false);
    setIsDocumentDivided([]);
    setSelectedFiles([]);
    setProgress(0);
  };

  const handleFileDrop = (acceptedFiles) => {
    if (isUploadEnded) clear(); // Reset dello stato se l'upload è terminato

    const validFiles = acceptedFiles?.filter(
      (file) =>
        (file.type === "application/pdf" || file.type.startsWith("image/")) &&
        (appConfig?.modules?.documents?.zipUpload || file.path === file.name)
    );

    if (
      appConfig?.modules?.documents?.zipUpload &&
      acceptedFiles.some((file) => file.name.endsWith(".zip"))
    ) {
      acceptedFiles.forEach((file) => {
        if (file.name.endsWith(".zip")) {
          // Gestione degli ZIP
          const reader = new FileReader();

          try {
            reader.onload = async (e) => {
              const zip = await JSZip.loadAsync(e.target.result);

              const filePromises = [];
              zip.forEach((_, zipEntry) => {
                if (
                  !zipEntry.name.startsWith("__MACOSX") && // Esclude la cartella __MACOSX
                  !zipEntry.name.startsWith("Thumbs.db") && // Esclude i file Thumbs.db di Windows
                  !zipEntry.name.startsWith("desktop.ini") && // Esclude i file desktop.ini di Windows
                  !zipEntry.name.includes("/._") && // Esclude i file con prefisso ._
                  !zipEntry.name.startsWith("._") &&
                  (zipEntry.name.endsWith(".pdf") ||
                    zipEntry.name.match(/^.*\.(jpg|jpeg|png)$/)) // Filtra i file validi
                ) {
                  filePromises.push(
                    zipEntry.async("blob").then((blob) => {
                      const extractedFile = new File(
                        [blob],
                        zipEntry.name.split("/").pop(),
                        {
                          type: zipEntry.name.endsWith(".pdf")
                            ? "application/pdf"
                            : blob.type || "image/png", // Tipo predefinito
                          lastModified: Date.now(),
                        }
                      );

                      validFiles.push(extractedFile);
                    })
                  );
                }
              });

              // Una volta estratti i file dallo ZIP, aggiorna lo stato
              await Promise.all(filePromises);
              if (validFiles.length > 0) {
                setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
              } else {
                toast.error(t("InvalidFile"));
              }
            };
          } catch (error) {
            toast.error(t("InvalidZIPFile"));
          }

          reader.readAsArrayBuffer(file);
        }
      });
    } else {
      if (validFiles.length > 0) {
        setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
      } else {
        toast.error(t("InvalidFile"));
      }
    }
  };

  const rimuoviFile = (index) => {
    const nuoviFiles = [...selectedFiles];
    nuoviFiles.splice(index, 1);
    setSelectedFiles(nuoviFiles);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const createDocumentData = (files, selectedUser) => {
    const firstFile = files[0];
    const fileExtension = firstFile.name.split(".").pop();
    const fileName = firstFile.name;
    const documents = files.map((file) => ({
      Extension: file.name.split(".").pop(),
      FileName: file.name,
    }));
    const documentData = {
      ownerId: selectedUser.id,
      extension: fileExtension,
      fileName: fileName,
      name: fileName,
      filesCount: files.length,
      referenceYear: new Date().getFullYear(),
      scope: "PERSONAL",
      documents: documents,
      avoidAIAnalysis: false, //test
      practiceId: selectedPractice,
    };
    return documentData;
  };

  const updateProgress = (percentage) => {
    setProgress(percentage);
  };

  const confermaCaricamento = async () => {
    if (selectedFiles.length > 0 && selectedUser) {
      setLoading(true);
      setIsUploadEnded(true);
      const totalFiles = selectedFiles.length;
      let uploadedFilesCount = 0;
      let uploadUrlResponse;
      try {
        for (const file of selectedFiles) {
          uploadUrlResponse = await dispatch(getUploadURL(selectedUser.id));
          const uploadUrl = uploadUrlResponse.payload;
          await dispatch(
            uploadFile({
              url: uploadUrl,
              file: new Blob([file]),
              type: file.type,
            })
          );
          const documentData = createDocumentData([file], selectedUser);
          documentData.S3FilePath = uploadUrl;
          const cleanedUrl = documentData.S3FilePath.split("?")[0];
          const cleanedDocumentData = {
            ...documentData,
            S3FilePath: cleanedUrl,
          };
          (selectedPractice
            ? createPracticeDocument({
                cleanedDocumentData: cleanedDocumentData,
                practiceId: selectedPractice,
              })
            : createDocument(cleanedDocumentData)
          ).then((res) => {
            file.id = res.data.Data?.id;
            file.files = res.data.Data?.files;
            loadPdf(file);
          });
          uploadedFilesCount++;
          const currentProgress = Math.round(
            (uploadedFilesCount / totalFiles) * 100
          );
          updateProgress(currentProgress);
          if (uploadedFilesCount === totalFiles) {
            setLoading(false);
            toast.success(t("DocsLoaded"));
          }
        }
        setIsAllDocumentsUploaded(true);
      } catch (error) {
        console.error(error);
        toast.error(t("DocsNotLoaded"));

        setLoading(false);
      }
    }
  };

  const handleOpen = (file) => {
    setFile(file);
    setOpen(true);
  };

  return (
    <div className="w-11/12">
      <LockScreen
        text={
          <div className="w-full text-center mt-4 flex flex-col items-center gap-4">
            <h3> {t("UploadingDocExt")}</h3>
            <div className="w-96">
              <div>{progress + "%"}</div>

              <DotLottieReact
                src="https://lottie.host/640307c9-8f67-4933-a20b-5ccca2473aac/D56P0e8La1.json"
                loop
                autoplay
              />
            </div>
          </div>
        }
        openTrigger={loading}
        zIndex={10000}
      />
      <div className="w-full">
        <div className="flex  items-center w-full ">
          <CoreBack />
          <h2>{t("UploadDoc")}</h2>
        </div>
        <p className="m-0">{t("SearchAndSelectTheUserForDoc")}</p>
        <div className="py-2">
          <CoreButtonHoverIcon
            className="text-blue-800 m-1"
            icon={<AddBoxRoundedIcon className="text-blue-800" />}
            testo={t("CreateUser")}
            onClick={() => setCreaUtente(true)}
          />
        </div>
        <Box component={Paper} elevation={5}>
          <div className="flex p-8 space-x-8" style={{ height: "65vh" }}>
            <div className="w-3/12">
              <div className="flex flex-col gap-6">
                <UserFilter
                  disabled={selectedFiles.length > 0 ? true : false}
                  selectedUser={selectedUser}
                  setSelectedUser={setSelectedUser}
                  usersList={usersData?.Data?.items || []}
                  setDebouncedInputUserValue={setDebouncedInputUserValue}
                  isUsersLoading={isUsersLoading || isUsersFetching}
                />
                {appConfig?.modules?.practice?.general && (
                  <div
                    style={{ border: "1px solid lightgrey" }}
                    className="p-4"
                  >
                    <div className="w-full flex items-center justify-between mb-1">
                      <FormControlLabel
                        label={t("UploadPracticeDoc")}
                        control={
                          <Checkbox
                            checked={checkedEsitoPratica.generalCheckBox}
                            onChange={() =>
                              setCheckedEsitoPratica({
                                ...checkedEsitoPratica,
                                generalCheckBox:
                                  !checkedEsitoPratica.generalCheckBox,
                              })
                            }
                          />
                        }
                      />
                      <IconButton
                        onClick={() =>
                          setCheckedEsitoPratica({
                            ...checkedEsitoPratica,
                            showInfo: !checkedEsitoPratica.showInfo,
                          })
                        }
                      >
                        <InfoRoundedIcon
                          style={{
                            color: checkedEsitoPratica.showInfo
                              ? primaryColor
                              : "lightgrey",
                          }}
                        />
                      </IconButton>
                    </div>
                    {checkedEsitoPratica.showInfo && (
                      <p className="italic text-xs m-0 mb-3">
                        {t("UploadPracticeDocExt")}
                      </p>
                    )}
                    {checkedEsitoPratica.generalCheckBox && (
                      <CoreSelectObjArr
                        disabled={!selectedUser}
                        label={`${t("SelectPractice")}`}
                        value={selectedPractice?.id}
                        onChange={(e) => setSelectedPractice(e.target.value)}
                        items={[
                          {
                            value: null,
                            label: <p className="italic m-0">{t("NoOne")}</p>,
                          },
                        ].concat(
                          practicesData?.Data?.items.map((p) => ({
                            value: p.id,
                            label: p.name,
                          })) || []
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="w-4/12">
              {selectedUser &&
              (!checkedEsitoPratica.generalCheckBox ||
                (checkedEsitoPratica.generalCheckBox && selectedPractice)) ? (
                <Dropzone onDrop={handleFileDrop} accept={["image/*", ".pdf"]}>
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className="flex justify-center items-center"
                      {...getRootProps()}
                      style={{
                        minHeight: "60vh",
                        maxWidth: "600px",
                        padding: "20px",
                        border: "2px dashed #ccc",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />
                      <Box display="flex" flexDirection="column">
                        <p className="text-center text-gray">{t("DropFile")}</p>
                        <CoreButtonIcon
                          icon={
                            <UploadFileRoundedIcon
                              className="text-gray"
                              sx={{ fontSize: 70 }}
                            />
                          }
                        />
                        <CoreButtonIcon
                          icon={<SearchRoundedIcon className="text-gray" />}
                          testo={t("Search")}
                          className="text-gray"
                        />
                      </Box>
                    </div>
                  )}
                </Dropzone>
              ) : (
                <div
                  className="flex justify-center items-center text-gray"
                  style={{
                    minHeight: "60vh",
                    maxWidth: "600px",
                    padding: "20px",
                    border: "2px dashed #ccc",
                    textAlign: "center",
                  }}
                >
                  {selectedUser ? t("SelectPractice") : t("SelectUser")}
                </div>
              )}
            </div>
            <div className="flex flex-col w-5/12">
              {selectedFiles.length > 0 && (
                <>
                  <h3 className="mx-4">
                    {isUploadEnded ? t("DocsLoaded") : t("DocsToLoad")}
                  </h3>
                  {loading ? (
                    <></>
                  ) : (
                    <div className="overflow-y-scroll w-full h-8/12 p-2 border-solid  border border-stone-100 rounded-md">
                      {selectedFiles &&
                        selectedFiles.map((file, index) => (
                          <div
                            key={index}
                            className="flex items-center space-x-1"
                          >
                            <p>{file.name}</p>
                            {isUploadEnded ? (
                              <>
                                <CheckCircleIcon className="text-green-700" />
                                {isDocumentDivided[file.id] ? (
                                  <TaskRoundedIcon className="text-green-700" />
                                ) : (
                                  file.type === "application/pdf" &&
                                  pages[file.id] > 1 && (
                                    <button
                                      onClick={() => handleOpen(file)}
                                      className="Btn"
                                      style={{ backgroundColor: colorPrimary }}
                                    >
                                      <div className="sign">
                                        <InsertPageBreakRoundedIcon fontSize="small" />
                                        <div className="text">
                                          {t("SplitDoc")}
                                        </div>
                                      </div>
                                    </button>
                                  )
                                )}
                              </>
                            ) : (
                              <IconButton>
                                <DeleteRoundedIcon
                                  onClick={() => rimuoviFile(index)}
                                  className="text-rose-700"
                                />
                              </IconButton>
                            )}
                          </div>
                        ))}
                    </div>
                  )}
                  <div>
                    {isAllDocumentsUploaded && (
                      <div className="flex flex-row mt-10 w-full gap-8 justify-center">
                        <CoreButton
                          className="btn-round"
                          onClick={() => clear()}
                          testo={t("Upload")}
                        />
                        <CoreButton
                          className="btn-round"
                          onClick={() =>
                            role === ROLE.ADMIN
                              ? navigate(
                                  "/auth/admin/" + t("documentManagement")
                                )
                              : role === ROLE.BUSINESS &&
                                subrole === SUB_ROLE.ADMIN
                              ? navigate(
                                  "/auth/business/" + t("documentManagement")
                                )
                              : navigate(
                                  "/auth/operator/" + t("documentManagement")
                                )
                          }
                          testo={t("Archive")}
                        />
                      </div>
                    )}
                    {!isUploadEnded && (
                      <div className="text-center mt-4 py-4 space-x-8">
                        <CoreButton
                          className="btn-round"
                          onClick={() => clear()}
                          testo="Reset"
                        />

                        <CoreButton
                          className="btn-round"
                          onClick={confermaCaricamento}
                          testo={t("Upload")}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </Box>
        <CoreModal
          width={"100%"}
          height={"100%"}
          onClose={handleClose}
          state={open}
          component={
            <SplitDocumentPage
              document={file}
              numPages={numPages}
              onClose={handleClose}
              setIsDocumentDivided={setIsDocumentDivided}
            />
          }
        />
        <CoreModal
          width={600}
          height={"fit-content"}
          onClose={() => setCreaUtente(false)}
          state={creaUtente}
          component={
            <div className="w-full">
              <h3 className="text-center">{t("CreateUser")}</h3>
              <FormCreaUtenteAdmin
                onClose={() => setCreaUtente(false)}
                isOperator={false}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default CaricaDocumentiPage;
